import _ from 'lodash';

// this file includes utility functions
// for storage & artifact tracking (aka reference)

export const STORAGE_LIMIT_GB = 100;
export const ARTIFACT_TRACKING_LIMIT_GB = 100;

export const bytesInGB = 1000000000;
export const bytesInTB = bytesInGB * 1000;

export const freeStorage = bytesInGB * 100;

export const storagePrices = [0.0, 0.08, 0.06, 0.05];
export const artifactPrices = [0.0, 0.05, 0.03, 0.02];

export const storageTiers = [
  bytesInGB * 100,
  bytesInTB * 10,
  bytesInTB * 100,
  bytesInTB * 1000,
];

export const storageFeatures = [
  `$${storagePrices[1]} per GB up to ${storageTiers[1] / bytesInTB} TB`,
  `$${storagePrices[2]} per GB up to ${storageTiers[2] / bytesInTB} TB`,
  `$${storagePrices[3]} per GB up to ${storageTiers[3] / bytesInTB} TB`,
  `Over ${storageTiers[3] / bytesInTB} TB, contact us`,
];

export const artifactFeatures = [
  `$${artifactPrices[1]} per GB up to ${storageTiers[1] / bytesInTB} TB`,
  `$${artifactPrices[2]} per GB up to ${storageTiers[2] / bytesInTB} TB`,
  `$${artifactPrices[3]} per GB up to ${storageTiers[3] / bytesInTB} TB`,
  `Over ${storageTiers[3] / bytesInTB} TB, contact us`,
];

export function getTotalStorageBytes(
  entities?: Array<{storageBytes: number}>
): number | undefined {
  if (entities == null) {
    return undefined;
  }

  return _.sumBy(entities, 'storageBytes');
}

export function getTotalArtifactTrackingBytes(
  entities?: Array<{referenceBytes: number}>
): number | undefined {
  if (entities == null) {
    return undefined;
  }

  return _.sumBy(entities, 'referenceBytes');
}

export const TRACKED_HOURS = [
  `Tier 1 up to 5,000 tracked hours`,
  `Tier 2 up to 10,000 tracked hours`,
  `Tier 3 up to 15,000 tracked hours`,
  `Over 15,000 hours, contact us`,
];

// const BYTE_TIER_4 = 1000 * bytesInTB;
const BYTE_TIER_3 = 100 * bytesInTB;
const BYTE_TIER_2 = 10 * bytesInTB;
const BYTE_TIER_1 = 100 * bytesInGB;

const STORAGE_PRICE_PER_GB_TIER_3 = 0.05;
const STORAGE_PRICE_PER_GB_TIER_2 = 0.06;
const STORAGE_PRICE_PER_GB_TIER_1 = 0.08;

const ARTIFACT_PRICE_PER_GB_TIER_3 = 0.02;
const ARTIFACT_PRICE_PER_GB_TIER_2 = 0.03;
const ARTIFACT_PRICE_PER_GB_TIER_1 = 0.05;

// TODO: move this calculation to backend
export function getEstimatedStorageCharge(storageByte: number): number {
  let totalEstimate = 0;
  if (storageByte > BYTE_TIER_3) {
    totalEstimate +=
      STORAGE_PRICE_PER_GB_TIER_3 * ((storageByte - BYTE_TIER_3) / bytesInGB);
  }
  if (storageByte > BYTE_TIER_2) {
    totalEstimate +=
      STORAGE_PRICE_PER_GB_TIER_2 *
      ((Math.min(storageByte, BYTE_TIER_3) - BYTE_TIER_2) / bytesInGB);
  }
  if (storageByte > BYTE_TIER_1) {
    totalEstimate +=
      STORAGE_PRICE_PER_GB_TIER_1 *
      ((Math.min(storageByte, BYTE_TIER_2) - BYTE_TIER_1) / bytesInGB);
  }

  return totalEstimate;
}

// TODO: move this calculation to backend
export function getEstimatedArtifactReferenceCharge(
  referenceByte: number
): number {
  let totalEstimate = 0;
  if (referenceByte > BYTE_TIER_3) {
    totalEstimate +=
      ARTIFACT_PRICE_PER_GB_TIER_3 * (referenceByte - BYTE_TIER_3 / bytesInGB);
  }
  if (referenceByte > BYTE_TIER_2) {
    totalEstimate +=
      ARTIFACT_PRICE_PER_GB_TIER_2 *
      ((Math.min(referenceByte, BYTE_TIER_3) - BYTE_TIER_2) / bytesInGB);
  }
  if (referenceByte > BYTE_TIER_1) {
    totalEstimate +=
      ARTIFACT_PRICE_PER_GB_TIER_1 *
      ((Math.min(referenceByte, BYTE_TIER_2) - BYTE_TIER_1) / bytesInGB);
  }
  return totalEstimate;
}
